import script from "./ColumnSimilar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColumnSimilar.vue?vue&type=script&lang=ts&setup=true"

import "./ColumnSimilar.vue?vue&type=style&index=0&id=0187e462&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0187e462"]])

export default __exports__